import { LocalDate } from "../time";
/**
 * 2020-01-01, 2020/01/01, 2020年01月01日(火) などの形式のLocalDateを扱うえるようにするスキーマ
 */
const StringifyLocalDateSchema = LocalDate.stringSchema.pipe(LocalDate.schema);
export const StringifyLocalDate = {
    schema: StringifyLocalDateSchema,
};
//# sourceMappingURL=stringify-local-date.js.map